<template>
  <!-- 退件单 -->
  <div class="Box">
    <el-card>
      <div class="scanClass">
        <span>{{ $t('collectionCenter.returnNote') }}</span>
        <el-input
          v-model="returnNoteVal"
          :placeholder="$t('collectionCenter.scanOrInputParcelNumber')"
          clearable
          @keyup.enter.native="addReturnData"
        />
      </div>
    </el-card>
    <el-card style="margin-top: 10px">
      <div style="margin-bottom: 20px;">
        <span style="font-weight: bold; font-size: 14px;color: #606266;margin-right: 20px">
          {{ $t('collectionCenter.scanned') }}：<span style="color: #409eff">{{ tableData.length }}</span>
        </span>
        <el-button type="primary" size="small" @click="toReturn">{{ $t('collectionCenter.InitiateRejection') }}</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        :max-height="600"
        style="width: 100%"
        :header-cell-style="{background: '#ebebeb', color: '#606266'}"
      >
        <!-- 序号 -->
        <el-table-column :label="$t('collectionCenter.ind')" prop="ind" align="center" width="60" />
        <!-- 运单号 -->
        <el-table-column :label="$t('collectionCenter.waybillNumber')" prop="waybillNumber" align="center" />
        <!-- 扫描单号 -->
        <el-table-column :label="$t('collectionCenter.ScanNumber')" prop="ScanNumber" align="center" />
        <!-- 扫描人 -->
        <el-table-column :label="$t('collectionCenter.scanner')" prop="person" align="center" />
        <!-- 扫描时间 -->
        <el-table-column :label="$t('collectionCenter.scanTime')" prop="scanTime" align="center" />
        <el-table-column :label="$t('collectionCenter.operation')" align="center">
          <template slot-scope="scope">
            <el-popconfirm
              :title="$t('collectionCenter.deleteSure')"
              @confirm="del(scope.$index)"
            ><!-- 确定删除吗？ -->
              <div slot="reference" style="cursor: pointer;color: red">{{ $t('collectionCenter.Delete') }}</div><!-- 删除 -->
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      :title="$t('collectionCenter.tips')"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      class="returnDialogClass"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <span>{{ $t('collectionCenter.initiateReturnTotal') }}：{{ sumbitMsg.reverseTotal }}</span>
        <div style="margin-top: 20px;margin-bottom: 20px">
          <span style="display: inline-block; width: 50%">{{ $t('collectionCenter.orderSuccessful') }}：{{ sumbitMsg.reverseSuccess }}</span>
          <span style="display: inline-block; width: 50%">{{ $t('collectionCenter.orderFailure') }}：{{ sumbitMsg.reverseFailList ? sumbitMsg.reverseFailList.length : 0 }}</span>
        </div>
        <div v-if="sumbitMsg.reverseFailList && sumbitMsg.reverseFailList.length > 0">
          <span>{{ $t('collectionCenter.orderFailedOrder') }}：</span>
          <el-table
            :data="sumbitMsg.reverseFailList"
            :show-header="false"
            :max-height="500"
          >
            <el-table-column prop="ind" :label="$t('collectionCenter.ind')" width="60" />
            <el-table-column prop="waybillNumber" :label="$t('collectionCenter.order')" />
            <el-table-column prop="failReason" :label="$t('collectionCenter.reason')" />
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="handleClose" size="small">{{ $t('collectionCenter.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { reverseScan, reverseSumbit } from '@/api/automaticSorting';
import dayjs from 'dayjs';
export default {
  name: 'ReturnNote',
  data() {
    return {
      returnNoteVal: '',
      tableData: [],
      dialogVisible: false,
      sumbitMsg: {}
    };
  },
  methods: {
    addReturnData() {
      if (!this.returnNoteVal) return;
      reverseScan(this.returnNoteVal).then(res => {
        if (res.code === 200) {
          const isAdd = this.tableData.some(el => {
            if (this.tableData.length >= 1) {
              return el.waybillNumber === res.data.forwardWaybillNumber;
            }
          });
          if (isAdd) {
            this.$message({
              message: this.$t('collectionCenter.repeatDataTips'),
              type: 'warning'
            });
            return;
          }
          this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          this.tableData.push({
            ind: this.tableData.length + 1,
            waybillNumber: res.data.forwardWaybillNumber,
            ScanNumber: res.data.scanOrderNumber,
            person: this.$store.state.user.realName,
            scanTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
          });
          this.returnNoteVal = '';
        }
      });
    },
    del(ind) {
      this.tableData.splice(ind, 1);
    },
    toReturn() {
      if (this.tableData.length <= 0) {
        this.$message.warning(this.$t('GlobalSetObj.notDataUpload'));
        return;
      }
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const form = {
        waybillNumbers: this.tableData.map(arr => arr.waybillNumber)
      };
      reverseSumbit(form).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          this.sumbitMsg = res.data;
          this.sumbitMsg.reverseFailList = res.data.reverseFailList.map((arr, ind) => {
            return {
              ind: ind + 1,
              waybillNumber: arr.waybillNumber,
              failReason: arr.failReason
            };
          });
          this.dialogVisible = true;
          this.tableData = [];
        }
      }).finally(() => {
        loading.close();
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.sumbitMsg = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.scanClass{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}
.scanClass ::v-deep .el-input{
  width: 30%;
  margin-left: 10px;
}
.returnDialogClass ::v-deep .el-dialog__footer {
  text-align: center;
}
.selectClass ::v-deep .el-form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
